export const PENDING_REFUND_REASONS = {
  TECHNICAL_ISSUE: "technical_issue",
  GENERAL: "general", // used only after booking cancellation request is approved by CS
  PRICE_CHANGED: "price_changed",
  SOLD_OUT: "sold_out",
  DUPLICATES: "duplicates",
  SCHEDULE_CHANGE: "schedule_change",
  INVALID_CUSTOMER_DATA: "invalid_customer_data",
  INSURANCE: "insurance", // modal not shown
  MASS_REFUND: "mass_refund", // modal not shown
} as const
